export const DISCOVERY_REFRESH_INTERVAL_MS = 15_000;

export function discoveryRefreshInterval(visibilityState: DocumentVisibilityState): number | false {
  return visibilityState === 'visible' ? DISCOVERY_REFRESH_INTERVAL_MS : false;
}

export function preservedDiscoveryIndex<T extends { id: string }>(
  cards: readonly T[],
  fallbackIndex: number,
  activeCandidateId?: string,
  returnedCandidateId?: string,
): number {
  const preferredId = returnedCandidateId ?? activeCandidateId;
  if (preferredId) {
    const preferredIndex = cards.findIndex((card) => card.id === preferredId);
    if (preferredIndex >= 0) return preferredIndex;
  }
  return fallbackIndex < cards.length ? fallbackIndex : 0;
}
